import styled from 'styled-components';

import { breakpoints } from '@/shared/styles';

export const Block = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 48px;
  padding: 6px;
  display: flex;
  position: relative;
  justify-content: space-around;
  gap: 28px;

  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  mix-blend-mode: overlay;

  @media (max-width: ${breakpoints.mobileLG}px) {
    flex-direction: column;
    gap: 0;
  }
`;
